// 引入business文件夹中或路由文件所有的路由
import purchaseRoutes from '@/router/business/purchase/index' // 招标采购路由
import agencyRoutes from '@/router/business/agency/index' // 招标采购代理路由
import supplierRoutes from '@/router/business/supplier/index' // 投标报价路由
import supplierManageRoutes from '@/router/business/supplier-manage/index' // 供应商管理路由
import monitorRoutes from '@/router/business/monitor' // 查询统计路由
import performanceRoutes from '@/router/business/performance' // 采购履约（部分）路由
import riskRoutes from '@/router/business/risk' // 风险治理路由

export default [
  purchaseRoutes,
  agencyRoutes,
  supplierRoutes,
  supplierManageRoutes,
  monitorRoutes,
  performanceRoutes,
  riskRoutes
]
